import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Box, Avatar, useTheme, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DataTable from '@ui/components/common/DataTable';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '@application/store/useStore';
import { getExternalRelationInterestsByRelationIdAsync } from '@application/features/externalrelationInterests/externalRelationInterestsThunk';
// Placeholder data
// const mockInterests: PeopleInterestDto[] = [
//   {
//     id: '1',
//     personId: 'relation-1',
//     interestId: 'interest-1',
//     title: 'Business Networking',
//     peopleCount: 45,
//     eventCount: 12
//   },
//   {
//     id: '2',
//     personId: 'relation-1',
//     interestId: 'interest-2',
//     title: 'Technology',
//     peopleCount: 38,
//     eventCount: 8
//   },
//   {
//     id: '3',
//     personId: 'relation-1',
//     interestId: 'interest-3',
//     title: 'Sports',
//     peopleCount: 52,
//     eventCount: 15
//   },
//   {
//     id: '4',
//     personId: 'relation-1',
//     interestId: 'interest-4',
//     title: 'Innovation',
//     peopleCount: 28,
//     eventCount: 6
//   },
//   {
//     id: '5',
//     personId: 'relation-1',
//     interestId: 'interest-5',
//     title: 'Charity',
//     peopleCount: 35,
//     eventCount: 10
//   },
//   {
//     id: '6',
//     personId: 'relation-1',
//     interestId: 'interest-6',
//     title: 'Professional Development',
//     peopleCount: 42,
//     eventCount: 9
//   },
//   {
//     id: '7',
//     personId: 'relation-1',
//     interestId: 'interest-7',
//     title: 'Entertainment',
//     peopleCount: 30,
//     eventCount: 7
//   },
//   {
//     id: '8',
//     personId: 'relation-1',
//     interestId: 'interest-8',
//     title: 'Racing',
//     peopleCount: 25,
//     eventCount: 5
//   }
// ];
const InterestsTabContent = ({ relationId }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10
    });
    const [searchValue, setSearchValue] = useState('');
    const dispatch = useAppDispatch();
    const { paginatedExternalRelationInterests } = useSelector((state) => state.externalRelationInterests);
    useEffect(() => {
        if (relationId) {
            const request = {
                pageNumber: paginationModel.page + 1,
                pageSize: paginationModel.pageSize,
                externalRelationId: relationId,
                searchString: searchValue.trim()
            };
            dispatch(getExternalRelationInterestsByRelationIdAsync(request));
        }
    }, [dispatch, paginationModel.page, paginationModel.pageSize, relationId, searchValue]);
    const columns = [
        {
            key: 'name',
            label: t('settings.tagName') || 'Tag Name',
            width: '50%',
            render: (row) => (_jsx(Typography, { variant: 'body2', children: row.title }))
        },
        {
            key: 'numberOfEvents',
            label: t('settings.numberOfEvents') || 'Number of Events',
            align: 'center',
            width: '25%',
            render: (row) => (_jsx(Avatar, { sx: {
                    width: 32,
                    height: 32,
                    bgcolor: '#E8F5E9',
                    color: '#388E3C',
                    fontSize: '0.875rem',
                    fontWeight: 600,
                    mx: 'auto'
                }, children: row?.eventCount || 0 }))
        }
    ];
    return (_jsx(Box, { sx: {
            backgroundColor: theme.palette.common.whiteTransparent,
            height: '100%'
        }, children: _jsx(DataTable, { data: paginatedExternalRelationInterests ? paginatedExternalRelationInterests.items : [], columns: columns, getRowId: (row) => row.id, title: t('settings.tags'), onSearchChange: setSearchValue, searchPlaceholder: t('placeholders.search') || 'Search...', showSearchFilter: true, emptyMessage: t('settings.noTagsFound') || 'No tags found', toolbarPosition: 'right', pagination: true, page: paginationModel.page, rowsPerPage: paginationModel.pageSize, rowsPerPageOptions: [5, 10, 25, 50], totalCount: paginatedExternalRelationInterests?.totalCount, onPageChange: (newPage) => setPaginationModel((prev) => ({ ...prev, page: newPage })), onRowsPerPageChange: (newRowsPerPage) => setPaginationModel((prev) => ({ ...prev, pageSize: newRowsPerPage })) }) }));
};
export default InterestsTabContent;
